import { render } from "./ai-form-number-box.vue?vue&type=template&id=cfae8d4c"
import script from "./ai-form-number-box.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-form-number-box.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/card-component/ai-form-number-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cfae8d4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cfae8d4c', __exports__)) {
    api.reload('cfae8d4c', __exports__)
  }
  
  module.hot.accept("./ai-form-number-box.vue?vue&type=template&id=cfae8d4c", () => {
    api.rerender('cfae8d4c', render)
  })

}


export default __exports__